export { default } from './AccommodationDetailed'
